/********************************************************************************
 * Global Variables, Constants and Types
 ********************************************************************************/

export const DEFAULT_PAGE_SIZE = 25;

export const PAGE_SIZES = [
  { value: '10', label: '10' },
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
  { value: '200', label: '200' },
];
